module.exports = __webpack_public_path__ + "static/media/john-kaplanis-resume.cdae273f.pdf";